<template>
  <div class="login-page">
    <div class="login-panel">
      <div class="login-language">
        <el-select v-model="language" size="mini" @change="changeLanguage">
          <el-option label="EN" value="en"></el-option>
          <el-option label="FR" value="fr"></el-option>
        </el-select>
      </div>
      <div class="login-title">{{ $t('appTitle') }}</div>
      <el-form @submit.native.prevent="login">
        <el-form-item>
          <el-input v-model="form.username" :placeholder="$t('common.username')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.password" :placeholder="$t('common.password')" type="password" autocomplete="off" @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-button type="primary" class="login-button" :loading="loading" @click="login">{{ $t('actions.login') }}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getLanguage, hasLanguage, setToken, setUserId, setUsername } from '../store';

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      language: getLanguage(),
      form: {
        username: '',
        password: ''
      }
    };
  },
  methods: {
    changeLanguage(value) {
      this.$setLanguage(value);
    },
    async login() {
      if (!this.form.username || !this.form.password) {
        this.$message.error(this.$t('login.missing'));
        return;
      }
      this.loading = true;
      try {
        const resp = await this.$axios.post('/admin/exagent/console/login/', this.form);
        const data = resp.data;
        if (data.status !== 0) return;
        const payload = data.data || {};
        setToken(payload.token);
        setUserId(String(payload.user_id));
        setUsername(payload.username);
        if (!hasLanguage() && payload.language) {
          this.language = this.$setLanguage(payload.language);
        }
        this.$router.replace('/dashboard');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: #eef3f8;
}

.login-panel {
  width: 360px;
  max-width: 100%;
  padding: 28px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fff;
}

.login-title {
  margin-bottom: 22px;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
}

.login-button {
  width: 100%;
}

.login-language {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue